import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IDateRangePickerDate } from '../../shared/components/date-range-picker/date-range-picker.interface';

export function DateRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value } = control;

    if (
      !value ||
      typeof value !== 'object' ||
      !('startDate' in value) ||
      !('endDate' in value) ||
      !(value as IDateRangePickerDate).startDate ||
      !(value as IDateRangePickerDate).endDate
    ) {
      return { required: true };
    }

    return null;
  };
}
